import { defineComponent as _defineComponent } from 'vue'
import {
  PropType,
  computed,
  onMounted,
  onUnmounted,
  ref,
  unref,
} from 'vue'

import {
  useI18n
} from '@/composables/useI18n';

import type {
  AvailableCardRanges,
} from '@/components/cards/scripts';

import {
  fetchAvailableCardRanges,
} from "@/composables/useAddCardsDialog";

import {
  isEndEqualOrHigherThanStart,
  isNumberInRanges,
  isStartAndEndInRanges,
} from "@/scripts/Common/validators/defaultValidator";
import {getToken} from "@/scripts/Common";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCardsDialog',
  props: {
  apiName: {
    required: true,
    type: String as PropType<string>,
  }
},
  emits: [
  'onDialogCancel',
  'onDialogConfirm',
  'onError',
],
  setup(__props, { emit: emits }) {

const props = __props;





const {
  t
} = useI18n();

const availableCardRanges = ref<AvailableCardRanges[]>([]);
const endNumber = ref<number>(0);
const isDialogVisible = ref<boolean>(false);
const reference = ref('');
const startNumber = ref<number>(0);
const templateRefFormAddCards = ref()

const countOfCreatedCards = computed(() => canAddCards ? endNumber.value - startNumber.value + 1 : 0)

const fetchCardRanges = async () => {
  const {error, cardRanges} = await fetchAvailableCardRanges(props.apiName, getToken());

  if(error){
    emits('onError', {error});
    return;
  }

  availableCardRanges.value = cardRanges.value;
}

const onHandleDialogCancel = () => {
  isDialogVisible.value = false;
  emits('onDialogCancel');
};

const onHandleDialogAddConfirm = () => {
  emits('onDialogConfirm', {
    cardEnd: unref(endNumber),
    cardStart: unref(startNumber),
    reference: unref(reference)
  });
};

const canAddCards = computed(() =>
  isStartAndEndInRanges(unref(availableCardRanges), unref(startNumber), unref(endNumber))
  && isEndEqualOrHigherThanStart(unref(startNumber), unref(endNumber))
);

onMounted(async () => {
  isDialogVisible.value = true;
  await fetchCardRanges();
});

onUnmounted(() => {
  isDialogVisible.value = false;
})

return { __sfc: true,props, emits, t, availableCardRanges, endNumber, isDialogVisible, reference, startNumber, templateRefFormAddCards, countOfCreatedCards, fetchCardRanges, onHandleDialogCancel, onHandleDialogAddConfirm, canAddCards, isEndEqualOrHigherThanStart, isNumberInRanges, isStartAndEndInRanges }
}

})